import { ComponentType } from "react";

import {
  AnyProductType,
  productTypeAccessory,
  productTypePackage,
  productTypeTire,
  productTypeWheel,
} from "../../constants/productTypes";
import { DealerAccessoriesPage } from "../../pages/DealerAccessoriesPage";
import { DealerPackagesPage } from "../../pages/DealerPackagesPage";
import { DealerTiresPage } from "../../pages/DealerTiresPage";
import { DealerWheelsPage } from "../../pages/DealerWheelsPage";
import { useGetVehiclePartTypes } from "../../queries/useGetVehiclePartTypes";
import { useDealerAccountInfo } from "./useDealerAccountInfo";

export const useDealerProducts = (): ProductOption[] => {
  const {
    dealerEnableAccessorySearch,
    dealerEnablePackageSearch,
    dealerEnableTireSearch,
    dealerEnableWheelSearch,
  } = useDealerAccountInfo();
  const { data = [] } = useGetVehiclePartTypes();
  const productsSet = new Set(data.map(({ value }) => value));
  const isDisabled = (productType: AnyProductType): boolean => {
    if (!productsSet.size) {
      return false;
    }
    return !productsSet.has(productType);
  };
  const products = [
    dealerEnableTireSearch && {
      Component: DealerTiresPage,
      isDisabled: isDisabled(productTypeTire),
      name: productTypeTire,
    },
    dealerEnableWheelSearch && {
      Component: DealerWheelsPage,
      isDisabled: isDisabled(productTypeWheel),
      name: productTypeWheel,
    },
    dealerEnableAccessorySearch && {
      Component: DealerAccessoriesPage,
      isDisabled: isDisabled(productTypeAccessory),
      name: productTypeAccessory,
    },
    dealerEnablePackageSearch && {
      Component: DealerPackagesPage,
      isDisabled: isDisabled(productTypePackage),
      name: productTypePackage,
    },
  ];
  return products.filter(Boolean) as ProductOption[];
};

type ProductOption = {
  Component: ComponentType;
  isDisabled: boolean;
  name: AnyProductType;
};
